const $ = window.jQuery;
const google = window.google;
const componentForm = {
	street_number: 'short_name', // eslint-disable-line camelcase
	route: 'long_name',
	locality: 'long_name',
	administrative_area_level_1: 'long_name', // eslint-disable-line camelcase
	country: 'long_name',
	postal_code: 'short_name' // eslint-disable-line camelcase
};

/**
 * Initialize functionality
 */
const init = () => {
	/*$('.bk-address-autocomplete input[type=text]').focus(function(){
		$(this).parent().addClass('address-autocomplete');
		let elems = document.querySelectorAll( '.address-autocomplete input[type=text]' );

		if ( elems ) {
			initAutocomplete( elems );
		}
	});*/
	$( document ).on( 'gform_post_render', function() {
		let elems = document.querySelectorAll( '.address-autocomplete input[type=text]' );

		if ( elems ) {
			initAutocomplete( elems );
		}
	} );
};

/**
 * Initialize any autocompletes.
 *
 * @param {NodeList} elements Address autocomplete elements
 */
const initAutocomplete = ( elements ) => {
	const options = {
		//types: [ 'geocode' ],
		types: [ '(regions)' ],
		componentRestrictions: {country: 'us'}
	};

	let autocomplete;

	for ( let i = 0; i < elements.length; ++i ) {
		const parent = $( elements[ i ] ).parents( '.ginput_container_address' );
		autocomplete = new google.maps.places.Autocomplete( elements[ i ], options );

		autocomplete.setFields( ['address_components'] );

		autocomplete.addListener( 'place_changed', function() {
			const place = autocomplete.getPlace();

			clearInputs( parent );

			for ( let i = 0; i < place.address_components.length; ++i ) {
				let addressType = place.address_components[ i ].types[0];

				if ( componentForm[ addressType ] ) {
					let val = place.address_components[ i ][ componentForm[ addressType ] ];

					if ( 'route' === addressType ) {
						addressType = 'street_number';
						val = `${parent.find( `.${addressType}` ).val()} ${val}`;
					}

					parent.find( `.${addressType}` ).val( val ).trigger( 'change' );
				}
			}
		} );

		google.maps.event.addDomListener( elements[ i ], 'keydown', function( e ) {
			if ( 13 === e.keyCode && $( '.pac-container:visible' ).length ) {
				e.preventDefault();
			}
		} );
	}
};

/**
 * Clear form inputs.
 *
 * @param {jQuery} parent Address block
 */
const clearInputs = ( parent ) => {
	for ( let component in componentForm ) {
		parent.find( `.${component}` ).val( '' );
	}
};

export default { init };
